import "react";
import { Tag } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Events/shared/EventInteractive/components/EventState.tsx
function EventState({ event }) {
	return /* @__PURE__ */ jsxs("div", { children: [
		event.state === "active" && /* @__PURE__ */ jsx(Tag, {
			variant: "positive",
			value: "Active"
		}),
		event.state === "closed" && /* @__PURE__ */ jsx(Tag, {
			variant: "neutral",
			value: "Closed"
		}),
		event.state === "pending" && /* @__PURE__ */ jsx(Tag, {
			variant: "caution",
			value: "Pending"
		})
	] });
}
//#endregion
export { EventState };

//# sourceMappingURL=EventState.js.map